import React from 'react';
import { List } from 'immutable';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { CoreLink, Paragraph } from '@uncinc/react-drupal-core';
import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  SCREEN_WIDE,
} from '@uncinc/uncinc-react-kitchen-sink/dist/Context/ViewportContext';

import { Container, ParallaxIllustrations, Hero } from '../../../../components';

import './style.scss';

const NodeHomePage = ({ entity, className }) => {
  const classes = classNames(className, 'HomePage');

  const { t } = useTranslation();
  const heroMedia = entity.getIn(['field_media_item', 0], null);
  const body = entity.getIn(['body', 0, 'value'], '');
  const links = entity.getIn(['field_menu'], '');

  const { bundle } = heroMedia.toJS();
  let image = null;
  let imageStyles = {};
  let video = null;
  if (bundle === 'image') {
    image = heroMedia.toJS();
    imageStyles = {
      [SCREEN_MOBILE]: image?.styles?.ratio_3_2_md,
      [SCREEN_TABLET]: image?.styles?.ratio_2_1_xl,
      [SCREEN_NORMAL]: image?.styles?.ratio_4_3_lg,
      [SCREEN_WIDE]: image?.styles?.ratio_16_9_xl,
    };
  } else {
    video = heroMedia.toJS();
  }

  return (
    // eslint-disable-next-line react/no-unknown-property
    <article typeof="schema:WebPage" className={classes}>
      {heroMedia && (
        <Hero
          image={image}
          video={video}
          imageStyles={imageStyles}
          className="HomePage__hero"
        />
      )}
      <ParallaxIllustrations
        className="container HomePage__parallax"
        elementClassName="HomePage__parallax__element"
      />
      <div className="HomePage__intro">
        <Container className="HomePage__intro__container">
          <div className="row">
            <div className="col-12 col-md-7 col-xl-8">
              <h1>{body}</h1>
            </div>
            {links && (
              <div className="col-12 col-md-5 col-xl-4">
                <div className="QuickLinks">
                  <p className="QuickLinks__title">{t('go_directly_to')}</p>
                  {links.map((link, index) => {
                    return (
                      <div key={link.getIn(['uuid'], index)} className="QuickLinks__link">
                        <CoreLink href={link.getIn(['alias'], link.getIn(['uri']))}>
                          <i className="icon-after icon-before icon-arrow-right icon-variant-4 moving-arrow" />
                          {link.getIn(['title'])}
                        </CoreLink>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </Container>
      </div>
      <div className="Paragraphs">
        {
          entity.getIn(['field_paragraphs'], List()).map((item, index) => {
            const paragraphId = item.get('target_id');
            const paragraph = item.getIn(['entity']);
            return (
              <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
            );
          })
        }
      </div>
    </article>
  );
};

export default NodeHomePage;
